import { z } from 'zod';
export const pressOneAiResultsSchema = z.object({
    observedAt: z.string().datetime({ offset: true }),
    items: z.array(z.object({ callId: z.string().min(1).max(200), phone: z.string().regex(/^\+?7\d{10}$/), startedAt: z.string().datetime({ offset: true }), isLead: z.boolean(), status: z.enum(['completed', 'failed']), durationMs: z.number().int().min(0).max(86400000).nullable() }).strict()).max(100),
}).strict();
//# sourceMappingURL=press-one-ai-results.dto.js.map